import type { NativeButtonProps } from '@paid-ui/components/button';

import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { useSnapshot } from 'valtio/react';

import { openNewProjectDialog } from '@paid-ui/blocks/global-flyout';
import { Button } from '@paid-ui/components/button';
import { PlusIcon } from '@paid-ui/icons/plus';
import { userManager } from '@paid-ui/models/user';

export const NewProjectButton = forwardRef<HTMLButtonElement, NativeButtonProps>(
  ({ hidden, className, ...restProps }, ref) => {
    const { disableContractActions } = useSnapshot(userManager);
    const invisible = hidden || disableContractActions;

    return (
      <Button
        ref={ref}
        variant="solid"
        full={false}
        onClick={openNewProjectDialog}
        className={twMerge(invisible ? 'pointer-events-none invisible select-none' : '', className)}
        {...restProps}
      >
        <span>New project</span>
        <PlusIcon />
      </Button>
    );
  },
);

NewProjectButton.displayName = 'NewProjectButton';
